//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DialogsAdeInstitutPredpokladProcesRealizace.ts						</Name>
//    <Description> Funkce pro otev�en� dialog� spojen�ch s Institucion�ln� p�edpoklady pro proces realizace </Description>
//    <Author>      JKLUSACEK													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-12-02                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.38.1
//AdtGeneratorConfig:[ T:(srvvprr) GID:(Web.Dia.Ts) V1:(ixs_prr,ixs_tip,priz_pov,priz_pov_ixb,aktivita,dat_zmena,zmenu_prov,priz_nevyzad,ixs_sro_predklad,ixs_sro_schvalov,ixs_tip_next,priz_pov_zapl,priz_pov_kompl,priz_pov_schv) V2:() K1:() K2:() K3:() ]

namespace Gordic.Adm.Dialogs {

    // AdeInstitutPredpokladProcesRealizace
    export function DetailAdeInstitutPredpokladProcesRealizaceDlg(
        parentContent: GContent,
        opt: {
            /** ixs_prr */
            ixs_prr: string | null,
            /** ixs_tip */
            ixs_tip: string | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** p��znak nov�ho z�znamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;
    var detailCommand = opt.grid ? false : true;

    // grid remote control, kv�li �ipk�m na detailu
    const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

    var detail = ['Gordic.Adm.WebControls.DetailAdeInstitutPredpokladProcesRealizace', { gridRemoteControl: gridRemoteControl }]

    const options = {
        ID: "AdmAdeInstitutPredpokladProcesRealizace#",
        ixs_prr: opt ? opt.ixs_prr : undefined,
        ixs_tip: opt ? opt.ixs_tip : undefined,
        newRecord: opt ? opt.newRecord : undefined,
        detailCommand: detailCommand
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
}

    // AdeInstitutPredpokladProcesRealizace
    export function SeznamAdeInstitutPredpokladProcesRealizaceDlg(
        parentContent: GContent,
        opt: {
            /** ixs_prr */
            ixs_prr: string | null,
            /** ixs_tip */
            ixs_tip: string | null,
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;

    var detail = ['Gordic.Adm.WebControls.SeznamAdeInstitutPredpokladProcesRealizace', { }]

    const options = {
        ID: "AdmAdeInstitutPredpokladProcesRealizace#",
        ixs_prr: opt ? opt.ixs_prr : undefined,
        ixs_tip: opt ? opt.ixs_tip : undefined,
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
  }

}
